package io.horion.cv.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.utils.Colors
import io.horion.cv.models.Testimonial
import io.horion.cv.styles.TestimonialCardCommentStyle
import io.horion.cv.styles.TestimonialCardContainerStyle
import io.horion.cv.styles.TestimonialCardImageStyle
import io.horion.cv.styles.TestimonialCardJobStyle
import io.horion.cv.styles.TestimonialCardNameStyle
import io.horion.cv.styles.TestimonialCardStarStyle
import io.horion.cv.utils.Constants.UBUNTU
import io.horion.cv.utils.Constants.POPPINS
import org.jetbrains.compose.web.css.px

@Composable
fun TestimonialCard(
    item: Testimonial,
    modifier: Modifier = Modifier
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val textColor = if (isDark) Colors.White else Colors.DarkBlue

    Column(
        modifier = TestimonialCardContainerStyle.toModifier().then(modifier),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Image(
            src = item.imgSrc,
            description = "testimonial image",
            modifier = TestimonialCardImageStyle.toModifier()
                .objectFit(ObjectFit.Cover)
                .styleModifier {
                    property("object-position", "top center")
                }
        )

        SpanText(
            item.comment,
            modifier = TestimonialCardCommentStyle.toModifier()
                .fontWeight(FontWeight.Light)
                .fontFamily(POPPINS)
                .color(textColor)
                .textAlign(TextAlign.Center)
        )

        Row(
            modifier = Modifier.margin(top = 15.px, bottom = 10.px),
            horizontalArrangement = Arrangement.Center
        ) {
            repeat(4) {
                Image(
                    src = "star.svg",
                    description = "star rating",
                    modifier = TestimonialCardStarStyle.toModifier()
                        .styleModifier {
                            property("filter", if (isDark) "brightness(0.85)" else "none")
                        }
                )
            }
        }

        SpanText(
            item.name,
            modifier = TestimonialCardNameStyle.toModifier()
                .fontFamily(UBUNTU)
                .fontWeight(FontWeight.Light)
                .color(textColor)
        )

        SpanText(
            item.job,
            modifier = TestimonialCardJobStyle.toModifier()
                .fontFamily(UBUNTU)
                .fontWeight(FontWeight.Medium)
                .color(textColor)
        )
    }
}